import React from 'react';
import moment from 'moment';
import { Text5 } from '../../../styles';
import { printRupee } from '../../../app_methods';
import { Icon, Button } from 'antd';
import { MONTH_MASTER } from '../../../constants';


export const getLedgerTableColumns = (params = {}) => {
    if (params.currentVirtualAccount?.is_connected_banking || params.currentVirtualAccount?.is_bipatriate_escrow) {
        return [
            {
                title: "Name",
                key: "file_name",
                render: (record) => <Text5>{record.file_name}</Text5>
            }, {
                title: "Date",
                key: "date",
                render: (record) => <Text5>{moment(record.duration_start_date).format("LL")}</Text5>
            }, {
                title: "Actions",
                key: "actions",
                align: "center",
                render: (record) =>
                    <div className="w-100 d-flex justify-content-center">
                        <Button type="link" onClick={() => params.downloadConnectedBankStatement(record)}><Icon type="download" /> Download</Button>
                    </div>
            }
        ]
    }
    else {
        return [
            {
                title: "Date",
                key: "created_at",
                render: (record) => <Text5>{moment(record.created_at).format("lll")}</Text5>
            }, {
                title: "Beneficiary",
                key: "beneficiary_account",
                render: (record) =>
                    <div>
                        <Text5>
                            {record.transaction_type == "credit" ? (record.beneficiary_account_number || "---") : (record.beneficiary_full_name && record.beneficiary_full_name.toUpperCase()) || "---"}
                        </Text5>
                    </div>
            }, {
                title: "UTR",
                key: "unique_transaction_reference",
                render: (record) =>
                    <div>
                        <Text5>{(record.unique_transaction_reference && record.unique_transaction_reference.toUpperCase()) || "---"}</Text5>
                    </div>
            }, {
                title: "Narration",
                width: "25%",
                key: "narration",
                render: (record) =>
                    <div>
                        <Text5>{(record.narration && record.narration.toUpperCase()) || "---"}</Text5>
                    </div>
            }, {
                title: <>Debit <Icon style={{ color: "red" }} type="arrow-up" /></>,
                key: "debit_amount",
                render: (record) => <Text5>{record.transaction_type == "debit" ? printRupee(record.transaction_amount, 3) : "---"}</Text5>
            }, {
                title: <>Credit <Icon style={{ color: "green" }} type="arrow-down" /></>,
                key: "credit_amount",
                render: (record) => <Text5>{record.transaction_type == "credit" ? printRupee(record.transaction_amount, 3) : "---"}</Text5>
            }, {
                title: "Closing Balance",
                key: "closing_balance",
                render: (record) => <Text5>{printRupee(record.closing_balance, 3)}</Text5>
            }
        ]
    }
}


export const ledgerTableFilterNodes = (virtual_accounts, merchant_payment_modes = [], currentVirtualAccount = {}, current_user={}) => {
    const current_year = moment().year();
    const current_month = moment().month() + 1;
    const years = Array((current_year - 2020) + 1).fill('').map((v, idx) => 2020 + idx).reverse();
    let filters = [
        {
            label: "Account No.",
            field: "virtual_account",
            placeholder: "Select Virtual Account",
            inputType: "select",
            width: 200,
            disabled: (virtual_accounts || []).length <= 1,
            preventClear: true,
            defaultValue: ((virtual_accounts || []).find(x => x.active) || {}).id,
            options: (virtual_accounts || []).map((account, idx) => {
                return {
                    key: idx,
                    value: account.id,
                    label: account.label
                }
            }),
        },
    ]
    if (current_user?.is_reseller && current_user.esda){
        filters.unshift({
            label: "Merchant",
            field: "submerchant_id",
            placeholder: "Merchant ID",
            width: 200,
            inputType: "select",
            showSearch: true,
            defaultValue: undefined,
            dependantFields: ['virtual_account'],
            options: current_user.submerchants ? current_user.submerchants.map((sub_merchant, index) => {
                let object = {};
                object.key = index;
                object.value = sub_merchant.id;
                object.label = sub_merchant.name+" ("+sub_merchant.email+")"
                return object;
            }): []

        })
    }

    if (!currentVirtualAccount.is_connected_banking && !currentVirtualAccount.is_bipatriate_escrow) {
        filters = filters.concat([
            {
                label: "Debit/Credit",
                field: "transaction_type",
                placeholder: "Select Transaction Type",
                inputType: "select",
                defaultValue: null,
                options: [{
                    key: "1",
                    value: "debit",
                    label: "Debit"
                }, {
                    key: "2",
                    value: "credit",
                    label: "Credit"
                }]
            }, {
                label: "Payment Mode",
                field: "payment_mode",
                placeholder: "Select Payment Mode",
                inputType: "select",
                defaultValue: undefined,
                options: merchant_payment_modes.map((mode, index) => {
                    return Object.create({
                        key: index + 1,
                        value: mode,
                        label: mode
                    })
                })
            },
            {
            label: "Date",
            field: "created_at",
            placeholder: "Enter Date",
            inputType: "date_range",
            preventClear: true,
            defaultValue: [moment().subtract(3, 'days'), moment()]
        }
        ]);
    }
    else{
        filters = filters.concat([
        {
        label: "Year",
        field: "year",
        inputType: "select",
        defaultValue: current_year,
        options: years.map((year, index) => {
            return Object.create({
                key: index + 1,
                value: year,
                label: year
            })
        })
    }, {
        label: "Month",
        field: "month",
        inputType: "select",
        defaultValue: current_month,
        options: MONTH_MASTER.map((month, index) => {
            return Object.create({
                key: index + 1,
                value: month.value,
                label: month.label
            })
        })
    }
        ])
    }
    return filters;
}